import Model from './Model'

export default class Payment extends Model {
  resource() {
    return 'payments'
  }

  get brandIcon() {
    if (!this.card || !this.card.brand) return
    try {
      return require(`@/assets/icons/cards/dark/${this.card.brand.toLowerCase()}.png`)
    } catch (error) {}
  }
}
